import HotelImageUrl from '@assets/icons/certificates/tags/hotel.svg';
import CondoImageUrl from '@assets/icons/certificates/tags/condo.svg';
import CruiseImageUrl from '@assets/icons/certificates/tags/cruise.svg';

import type { ItemTypeEnum } from '@share/common-types';

const TYPE_ICONS: Record<string, string> = {
  hotel: HotelImageUrl,
  condo: CondoImageUrl,
  cruise: CruiseImageUrl,
};

export const getIconForType = (type: ItemTypeEnum | string): string => {
  const key = String(type).toLowerCase();
  return TYPE_ICONS[key] ?? HotelImageUrl;
};

export const itemTypeMessageId = (type: ItemTypeEnum | string): string => {
  const key = String(type).toLowerCase();
  if (key === 'hotel') {
    return 'certificates.itemType.hotel';
  }
  if (key === 'cruise') {
    return 'certificates.itemType.cruise';
  }
  if (key === 'condo') {
    return 'certificates.itemType.condo';
  }
  return 'certificates.itemType.hotel';
};
